import { projects } from "../endpoints";
import useFetch from "../hooks/useFetch";
import Project from "../components/Projects/Project";

import { useClickFilter } from "../hooks/filtering";
import { useSearchBar } from "../hooks/search";

interface data {
  project: string;
  projectId: string;
  customer: string;
  refrence: string;
  methode: string;
  status: string;
  factuur: string;
  creationdate: string;
}


const ProjectsLayout = () => {
  const endpoint = projects;
  const { data, loading } = useFetch<data>(endpoint);

  const {
    searchEntry,
    setSearchEntry,

    setIsSearchFocused,

    handleFilterClick,
    shouldShowFilters,
    searchRef,
    getFilteredSearchProjects,
  } = useSearchBar(data);

  const {
    projectSort,
    toggleProjectSort,

    customerSort,
    toggleCustomerSort,

    refSort,
    toggleRefSort,

    getArrow,
    getFilteredData,
  } = useClickFilter();

   // Combine search and click filters
  const getFilteredAndSortedData = () => {
    if (!data) return [];
    
    const searchFiltered = getFilteredSearchProjects();
    
    return getFilteredData(searchFiltered);
  };


  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Projecten laden...</span>
                ) : (
                  `Projecten (TimeChimp)`
                )}
              </h1>
            </div>
            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                "Hier een overzicht van alle Projecten"
              )}
            </p>
          </div>
          <div className="relative flex-1 flex justify-end" ref={searchRef}>
            {/* Search area */}
            <div className="bg-white w-[50%] h-12 rounded-3xl flex justify-center my-auto border border-gray-200">
              <input
                className="h-6 w-[80%] m-auto focus:outline-none"
                onChange={(e) => setSearchEntry(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                value={searchEntry}
                placeholder="Zoeken..."
              />
            </div>

            {/* Filters */}
            {shouldShowFilters && (
              <div className="absolute top-full right-0 z-10 bg-white shadow-lg rounded-lg p-4 border border-gray-200 min-w-[50%] mt-2">
                <b className="text-gray-600 text-xs">Filters</b>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                  onClick={() => handleFilterClick("van:")}
                >
                  <b>Specefieke klant</b>
                  <div className="flex text-xs">
                    <b>van:</b>
                    <p> Klant</p>
                  </div>
                </div>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                  onClick={() => handleFilterClick("meth:")}
                >
                  <b>Factuur methode</b>
                  <div className="flex text-xs">
                    <b>meth:</b>
                    <p> methode</p>
                  </div>
                </div>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                  onClick={() => handleFilterClick("per:")}
                >
                  <b>Specifieke periode (maand)</b>
                  <div className="flex text-xs">
                    <b>per:</b>
                    <p> maand jaar</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Data Table */}
        <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto">
          <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
            <div
              className="w-[30%] flex cursor-pointer select-none"
              onClick={toggleProjectSort}
            >
              <b>Projecten</b>
              {getArrow(projectSort) && (
                <img
                  src={getArrow(projectSort)!}
                  className="h-5 w-auto ml-1"
                  alt=""
                />
              )}
            </div>
            <div
              className="w-[20%] flex cursor-pointer select-none"
              onClick={toggleCustomerSort}
            >
              <b>Klant</b>
              {getArrow(customerSort) && (
                <img
                  src={getArrow(customerSort)!}
                  className="h-5 w-auto ml-1"
                  alt=""
                />
              )}
            </div>
            <div
              className="w-[10%] flex cursor-pointer select-none"
              onClick={toggleRefSort}
            >
              <b>PR-ref</b>
              {getArrow(refSort) && (
                <img
                  src={getArrow(refSort)!}
                  className="h-5 w-auto ml-1"
                  alt=""
                />
              )}
            </div>
            <b className="w-[12%] text-left">Factuurmethode</b>
            <b className="w-[10%] text-center">Leeftijd</b>
            <b className="w-[17%] text-right">Acties</b>
          </div>

          {data &&
            getFilteredAndSortedData().map((project, index) => (
              <Project
                key={index}
                project={project.project}
                id={project.projectId}
                customer={project.customer}
                refrence={project.refrence}
                methode={project.methode}
                creation={project.creationdate}
                status={project.status}
                factuur={project.factuur}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsLayout;
